import React from 'react';
import GradientBorder from "@/components/GradientBorder.tsx";

interface SectionButtonProps {
    title: string;
    backgroundColor: string;
    imageUrl?: string | null;
    iconName?: string | null;
    iconColor?: string;
    iconFill?: boolean;
    iconWeight?: number;
    iconGrade?: number;
    iconOpticalSize?: number;
    badgeCount?: number;
    onClick: () => void;
}

const SectionButton: React.FC<SectionButtonProps> = ({
                                                         title,
                                                         backgroundColor,
                                                         imageUrl,
                                                         iconName,
                                                         iconColor = '#FFFFFF',
                                                         iconFill = false,
                                                         iconWeight = 400,
                                                         iconGrade = 0,
                                                         iconOpticalSize = 20,
                                                         badgeCount,
                                                         onClick,
                                                     }) => {
    const iconStyle = {
        fontVariationSettings: `'FILL' ${iconFill ? 1 : 0}, 'wght' ${iconWeight}, 'GRAD' ${iconGrade}, 'opsz' ${iconOpticalSize}`,
        color: iconColor,
    };

    return (
        <GradientBorder className="rounded-2xl w-20 sm:w-24 md:w-28 lg:w-32 shadow-xl border-0 border-purple-700 hover:shadow-md focus:outline-none transition-all duration-200">
            <button
                onClick={onClick}
                className="relative text-black bg-transparent rounded-2xl border-0 flex flex-col items-center justify-between p-2 sm:p-3 md:p-4 w-full h-full"
                style={{backgroundColor}}
                aria-label={title}
            >
                {/* Badge for unseen messages */}
                {badgeCount !== undefined && badgeCount > 0 && (
                    <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full min-w-5 h-5 flex items-center justify-center px-1 shadow-md">
                        {badgeCount > 99 ? '99+' : badgeCount}
                    </span>
                )}
                <div className="flex items-center justify-center w-full h-10 sm:h-12 md:h-14 lg:h-16 mb-1 sm:mb-2">
                    {imageUrl ? (
                        <img src={imageUrl} alt="" className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 !lg:w-14 !lg:h-14 object-contain"/>
                    ) : iconName ? (
                        <span className="material-symbols-outlined !text-4xl sm:!text-5xl md:!text-6xl lg:!text-6xl" style={iconStyle}>{iconName}</span>
                    ) : null}
                </div>
                <span
                    className="text-center text-[0.625rem] sm:text-xs md:text-sm lg:text-base font-bold text-gray-700 hyphens-auto break-words w-full leading-tight"
                    lang="de">{title}</span>
            </button>
        </GradientBorder>
    );
};

export default SectionButton;
